// ** React Imports
import { useState } from "react";

// ** Reused lesson engines (genuinely neutral media/content renderers)
import LessonContent from "src/layouts/components/coursePlayer/LessonContent/LessonContent";
import Details from "src/layouts/components/coursePlayer/Details";
import Comments from "src/layouts/components/Comments";

/******************************************************************
 * ##: FlixLessonStage
 * Content stage of the Flix player. Mounts the EXISTING lesson engines
 * (LessonContent = video/audio/text/questionnaire; Details = title, body
 * and attachments; Comments = lesson comments) so the Flix player plays
 * real content with full parity to the app player, without duplicating
 * that logic. Only the surrounding shell/playlist are new.
 * @param {Object} props - resolved active chapter/lesson + handlers
 * @returns {JSX.Element} - the `.flix-stage`
 * History:
 * 22-07-2026: Created
 ******************************************************************/
const FlixLessonStage = ({
  course,
  videos_info,
  activeChapter,
  activeLesson,
  activeChapterIndex,
  lessonsStatus,
  isSmallDevice,
  isLastChapter,
  isLastLesson,
  courseAddedAt,
  courseEndDate,
  authData,
  auth,
  updateVideoCurrentTimeHandler,
  updateAudioCurrentTimeHandler,
  onVideoProgress,
  completeCtaVisible,
  updateLessonAsCompleted,
  refreshLessonsStatus,
  moveToNextLesson,
}) => {
  const [tab, setTab] = useState("1");

  return (
    <div className="flix-stage">
      {/* Lesson box: video/audio/text engine + details/materials, one surface. */}
      <div className="flix-stage__lesson">
        <LessonContent
          isSmallDevice={isSmallDevice}
          activeChapter={activeChapter}
          courseAddedAt={courseAddedAt}
          courseEndDate={courseEndDate}
          isLastChapter={isLastChapter}
          isLastLesson={isLastLesson}
          moveToNextLesson={moveToNextLesson}
          updateLessonAsCompleted={updateLessonAsCompleted}
          refreshLessonsStatus={refreshLessonsStatus}
          course={course}
          videos_info={videos_info}
          details={activeLesson}
          lessonsStatus={lessonsStatus}
          updateVideoCurrentTimeHandler={updateVideoCurrentTimeHandler}
          updateAudioCurrentTimeHandler={updateAudioCurrentTimeHandler}
          onVideoProgress={onVideoProgress}
          completeCtaVisible={completeCtaVisible}
        />
        <Details
          authData={authData}
          details={activeLesson}
          tab={tab}
          setTab={setTab}
          activeChapter={activeChapter}
          activeChapterIndex={activeChapterIndex}
          courseAddedAt={courseAddedAt}
          showChapterNumbers={course?.show_chapter_numbers}
          hasTeaserAccess={course?.teaser_access === true}
        />
      </div>

      {/* Comments live in their own box, separate from the lesson box. */}
      {course?.allow_comments && (
        <Comments
          courseId={course?.course_id}
          chapterId={activeChapter?.chapter_id}
          lessonId={activeLesson?.lesson_id}
          auth={auth}
          isSmallDevice={isSmallDevice}
          userCanReply={course?.user_can_reply}
          activeChapter={activeChapter}
          courseAddedAt={courseAddedAt}
        />
      )}
    </div>
  );
};

export default FlixLessonStage;
